<aside class="loader-container" *ngIf="loader">
  <lib-loader></lib-loader>
</aside>

<ng-container *ngIf="!loader">
  <section class="reports-main-subcomponent-container">
    <div class="card pb-3">
      <div class="row mx-2 mt-3 print-no-padding">
        <div class="card-header">
          <h2 class="card-header-title mb-3">
            {{ 'reports_costs_title' | translation }}: {{ costsReportsData.report_grouping | translation }}
          </h2>
        </div>
        <div class="card-body">
          <div class="col-12 p-0 p-lg-2 irrigation-container print-no-padding">
            <div class="alert alert-info mb-2" role="alert" *ngIf="!hasReportsData()">
              {{ 'reports_no_data' | translation }}
            </div>
            <article *ngIf="hasReportsData()">
              <app-reports-costs-table *ngIf="!isNative"
                [costsReportsData]="costsReportsData">
              </app-reports-costs-table>
              <app-reports-costs-table *ngIf="isNative && getOrientation()==='landscape'"
                [costsReportsData]="costsReportsData">
              </app-reports-costs-table>
              <div class="row" *ngIf="isNative && getOrientation()!=='landscape'">
                <div class="col-12 alert alert-warning p-2 my-4 text-center">
                  {{ 'reports_alert_rotate_phone' | translation}}
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>
